import axios from "axios";

export const getTrailBalance = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=tb`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching trial balance:", error.message);
		throw error;
	}
};

export const getBalanceSheet = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=bs`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching balance sheet:", error.message);
		throw error;
	}
};

export const getIncomeStatement = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=is`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching income statement:", error.message);
		throw error;
	}
};

export const getProfitAndLoss = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=pl`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching profit and loss:", error.message);
		throw error;
	}
};

export const getPartyWiseProfitLoss = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=party-wise-pl`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching party-wise profit and loss:", error.message);
		throw error;
	}
};

export const getCustomerSummary = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=customer-summary`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching customer summary:", error.message);
		throw error;
	}
};

export const getSupplierSummary = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=supplier-summary`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching supplier summary:", error.message);
		throw error;
	}
};

export const getPartyStatement = async (type, id, fromDate, toDate) => {
	try {
		const params = new URLSearchParams({ type, id: String(id) });
		if (fromDate) params.append("fromDate", fromDate);
		if (toDate) params.append("toDate", toDate);
		const { data } = await axios({
			method: "get",
			url: `account/party-statement?${params.toString()}`,
		});
		return data;
	} catch (error) {
		console.error("Error fetching party statement:", error.message);
		throw error;
	}
};

export const getMainAccount = async () => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account?query=ma`,
		});

		return data;
	} catch (error) {
		console.log(error.message);
	}
};

export const getSubAccount = async (id) => {
	try {
		const { data } = await axios({
			method: "get",
			url: `account/${id}`,
		});

		return data;
	} catch (error) {
		console.log(error.message);
	}
};

export const updateAccount = async (id, values) => {
	try {
		await axios({
			method: "put",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `account/${id}`,
			data: {
				...values,
			},
		});
		return "success";
	} catch (error) {
		console.log(error.message);
	}
};
